$(document).ready(function(){
$('.landing-video-slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  prevArrow: '<div class="left-arrow-video"><svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.6366 14.7443C7.90707 14.4313 7.90707 13.9239 7.6366 13.6109L2.58582 7.76651L7.6366 1.9221C7.90707 1.60907 7.90707 1.10168 7.6366 0.788774C7.36614 0.475751 6.92764 0.475751 6.65718 0.788774L0.626953 7.76651L6.65717 14.7443C6.92764 15.0572 7.36614 15.0572 7.6366 14.7443Z" fill="white"/></svg></div>',
  nextArrow:'<div class="right-arrow-video"><svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.3634 0.255717C0.0929314 0.568679 0.0929314 1.07609 0.3634 1.38905L5.41418 7.23349L0.3634 13.0779C0.0929314 13.3909 0.0929314 13.8983 0.3634 14.2112C0.633857 14.5242 1.07236 14.5242 1.34282 14.2112L7.37305 7.23349L1.34283 0.255717C1.07236 -0.0572444 0.633857 -0.0572444 0.3634 0.255717Z" fill="white"/></svg></div>',
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false
      }
    },
    {
      breakpoint: 576,
      settings: {
         rows: 2,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        rows: 2,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
});
 document.addEventListener("DOMContentLoaded", function () {
    const videoCards = document.querySelectorAll(".landing-video-card");
    videoCards.forEach((card) => {
      const playBtn = card.querySelector(".play-btn");
      const video = card.querySelector("video");
      if (!video || !playBtn) return;
      playBtn.addEventListener("click", () => {
        document.querySelectorAll(".landing-video-card video").forEach((v) => {
          if (v !== video) {
            v.pause();
            v.currentTime = 0;
            v.removeAttribute("controls");
            const otherBtn = v.closest(".landing-video-card").querySelector(".play-btn");
            if (otherBtn) otherBtn.style.display = "flex";
          }
        });
        video.play();
        video.setAttribute("controls", "controls");
        playBtn.style.display = "none";
      });
      // When video ends, show play button again
      video.addEventListener("ended", () => {
        video.removeAttribute("controls");
        video.currentTime = 0;
        playBtn.style.display = "flex";
      });
    });
  });